import Section from "./Section";

const PermissionListItem = ({type, ...props}) => {
  return type === 'section' ?<Section {...props} /> : <Section {...props} />
}

export default PermissionListItem